import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { Enqiryentry } from "./enqiryentry.model";
import { Enquiryentrydetails  } from "./enquiryentrydetails.model";
import { Employee } from "../../login/shared/employee";
import { Commonmaster } from "../../commonmasters/commonmaster.model";

@Injectable({
  providedIn: 'root'
})
export class EnquiryentryService {

  selectedEnqiryentry : Enqiryentry;
  selectedEnquiryentrydetails : Enquiryentrydetails;
  EnquiryentrydetailsList :Enquiryentrydetails[];
  EmployeeList : Employee[];
  commonmaster : Commonmaster;

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDEnquiryentry(enqiryentry:Enqiryentry){

    enqiryentry.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    enqiryentry.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    enqiryentry.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    enqiryentry.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = enqiryentry;
    
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/EnquiryEntry/IUD', body, { headers: headers });
  
  }

  FetchAutogeneratedNumber() {
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/AutoGeneratedNumber', body, { headers: headers });
  }

  FetchEnquiryEntryByEnquiryNo(enqiryentry) {

    // var body = JSON.stringify(enqiryentry);
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/EnquiryEntry/Fetch', body, requestOptions).map(x => x.json());

    let body = enqiryentry;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/EnquiryEntry/Fetch', body, { headers: headers });
  }

  FetchEnquiryCustomersByEnquiryNo(enqiryentry) {

    // var body = JSON.stringify(enqiryentry);
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/EnquiryEntry/FetchList', body, requestOptions).map(x => x.json());

    let body = enqiryentry;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/EnquiryEntry/FetchList', body, { headers: headers });
  }

//-----------------------------EnquiryEntryList----Component-------------------------------------
  FetchEnquiryEntryList(){
 
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/EnquiryEntry/FetchList', body, { headers: headers });
  }

  FetchStaffList(){

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Staff', body, { headers: headers });
  }

  FetchStaffListbyEnquiryId(Number: any){
    this.commonmaster = new Commonmaster();
    this.commonmaster.Id =Number;
    this.commonmaster.IsEnquiry = Number; // Enquiry staff 
    let body =  this.commonmaster;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/StaffbyId', body, { headers: headers });
  }

}
